export const subtitles = [
  {
    startTime: 0,
    text: "",
    redFlag: false,
    flagged: false,
    disabled: true,
  },
  {
    startTime: 3,
    text: "This is our Hedge Fund Hoaxer.",
    redFlag: false,
    flagged: false,
    disabled: false,
  },
  {
    startTime: 5,
    text: "A ‘trusted’ advisor with decades of experience under his belt.",
    redFlag: false,
    flagged: false,
    disabled: false,
  },
  {
    startTime: 9,
    text: "He is a charismatic guy, and",
    redFlag: false,
    flagged: false,
    disabled: false,
  },
  {
    startTime: 11,
    text: "at 51 has set up one of London’s best known hedge funds.",
    redFlag: false,
    flagged: false,
    disabled: false,
  },
  {
    startTime: 15,
    text: "He started with the bank in the 90’s,",
    redFlag: false,
    flagged: false,
    disabled: false,
  },
  {
    startTime: 18,
    text: "and following a move to London,",
    redFlag: false,
    flagged: false,
    disabled: false,
  },
  {
    startTime: 20,
    text: "by 1995 he was heading the bank's global proprietary trading desk.",
    redFlag: false,
    flagged: false,
    disabled: false,
  },
  {
    startTime: 26,
    text: "In 1998 he had set up a hedge fund,",
    redFlag: false,
    flagged: false,
    disabled: false,
  },
  {
    startTime: 28,
    text: "recruiting his stepfather, brother and his wife to become part of the team.",
    redFlag: true,
    flagged: false,
    disabled: false,
  },
  {
    startTime: 34,
    text: "As his success grew",
    redFlag: false,
    flagged: false,
    disabled: false,
  },
  {
    startTime: 36,
    text: "our Hedge Fund Hoaxer began to invest in private ventures",
    redFlag: false,
    flagged: false,
    disabled: false,
  },
  {
    startTime: 39,
    text: "using investor capital, without their knowledge.",
    redFlag: true,
    flagged: false,
    disabled: false,
  },
  {
    startTime: 42,
    text: "This included a documentary on",
    redFlag: false,
    flagged: false,
    disabled: false,
  },
  {
    startTime: 45,
    text: "how Hitler faked his own death and a mounting of the musical Spring Awakening.",
    redFlag: true,
    flagged: false,
    disabled: false,
  },
  {
    startTime: 50,
    text: "He was fond of parties",
    redFlag: false,
    flagged: false,
    disabled: false,
  },
  {
    startTime: 52,
    text: "and regularly used client money to host lavish events, including hosting at the Italian Grand Prix.",
    redFlag: true,
    flagged: false,
    disabled: false,
  },
  {
    startTime: 59,
    text: "He believed in paying himself a justified amount",
    redFlag: false,
    flagged: false,
    disabled: false,
  },
  {
    startTime: 62,
    text: "and over the period of 2005 and 2008 this totalled £5.8m.",
    redFlag: true,
    flagged: false,
    disabled: false,
  },
  {
    startTime: 70,
    text: "He set up three separate companies for fake investment activity.",
    redFlag: true,
    flagged: false,
    disabled: false,
  },
  {
    startTime: 75,
    text: "The WCUK acted as an investment advisor both to the macro fund",
    redFlag: false,
    flagged: false,
    disabled: false,
  },
  {
    startTime: 80,
    text: "and a third company, the Weavering Capitol Fund, or the WCF,",
    redFlag: false,
    flagged: false,
    disabled: false,
  },
  {
    startTime: 85,
    text: "which was based in the British Virgin Islands.",
    redFlag: false,
    flagged: false,
    disabled: false,
  },
  {
    startTime: 88,
    text: "This really only existed on paper.",
    redFlag: true,
    flagged: false,
    disabled: false,
  },
];
